var OrgMember = Backbone.Model.extend({
    initialize: function (data, options) {
        this.org = options.org;
        this.removed = this._unsavedRemoved = false;
        this.bind('change', this.changeAttribute, this);
    },
    changeAttribute: function () {
        if (!this._unsavedAttributes) {
            this._unsavedAttributes = this.previousAttributes();
        }
    },
    needsRemoving: function () {
        return this._unsavedRemoved !== this.removed;
    },
    needsSaving: function () {
        if (this.needsRemoving()) {
            return true;
        }
        if (this._unsavedAttributes) {
            for (var k in this.attributes) {
                if (this._unsavedAttributes[k] != this.get(k)) {
                    return true;
                }
            }
        }
        return false;
    },
    isAdmin: function () {
        return !!this.get('admin');
    },
    isSelf: function () {
        return !!this.get('self');
    },
    setAdmin: function (value) {
        return this.set({'admin': value});
    },
    isRemoved: function () {
        return this.removed;
    },
    isJoined: function () {
        return !!this.get('uid');
    },
    setRemoved: function (value) {
        if (this.removed !== value) {
            this.removed = value;
            this.trigger('removedChange', this);
            if (this.collection) {
                this.collection.trigger('removedChange', this, this.collection);
            }
        }
        return this;
    },
    reset: function () {
        this._unsavedAttributes = this.toJSON();
        this._unsavedRemoved = this.removed;
    },
    resendInvite: function (callback) {
        this.org.resendInvite(this, callback);
    }
});

module.exports = OrgMember;



//////////////////
// WEBPACK FOOTER
// ./app/src/model/orgmember.js
// module id = w2pc
// module chunks = 1